import normalizeDate from './normalizeDate';

const getDateTitle = ({ operator, value, title = '' }) => {
  const dateOperators = {
    between: () => {
      const dates = value.split('_');
      return `${normalizeDate(dates[0])} - ${normalizeDate(dates[1], true)}`;
    },
    gt: () => `After ${normalizeDate(value)}`,
    lt: () => `Before ${normalizeDate(value)}`,
    notEquals: () => `Not on ${normalizeDate(value)}`,
    today: () => 'Today',
    yesterday: () => 'Yesterday',
    lastweek: () => 'Last 7 days',
    lastmonth: () => 'Last 30 days',
    last90days: () => 'Last 90 days',
    isSet: () => `${title} set`,
    notSet: () => `${title} not set`,
    equals: () => `${normalizeDate(value)}`,
  };

  return dateOperators[operator]?.() || title;
};

export default getDateTitle;
